import * as React from "react"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	register: Function
	errors: any
	watch: Function
	setValue: Function
}
const MafoQuestionThree: React.FC<MafoQuestionProps> = ({ register, errors, watch, setValue }) => {
	const questionOneValue = watch("question3")
	const hasOtherOptionSelected = Array.isArray(questionOneValue) ? questionOneValue.includes("e") : questionOneValue === "e"

	React.useEffect(() => {
		if (!hasOtherOptionSelected) {
			setValue("question3Other", "")
		}
	}, [hasOtherOptionSelected, setValue])

	return (
		<>
			<h3 className="mafo-headline text-left text-blue">3. Für wen hast Du TREK Protein Oat Bars gekauft? (Mehrfachnennung möglich)</h3>
			<div className="mx-auto text-left lg:max-w-[100%] pt-1">
				<ElemCheckboxMafo label={<>Für mich</>} className=" pb-2 text-green">
					<input type="checkbox" {...register("question3")} name="question3" value="a" className={"peer absolute hidden h-1 w-1 " + (errors.question3 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Für meine Partnerin/ meinen Partner</>} className=" pb-2 text-green">
					<input type="checkbox" {...register("question3")} name="question3" value="b" className={"peer absolute hidden h-1 w-1 " + (errors.question3 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Für mein Kind/ meine Kinder</>} className=" pb-2 text-green">
					<input type="checkbox" {...register("question3")} name="question3" value="c" className={"peer absolute hidden h-1 w-1 " + (errors.question3 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Für andere Familienmitglieder</>} className=" pb-2 text-green">
					<input type="checkbox" {...register("question3")} name="question3" value="d" className={"peer absolute hidden h-1 w-1 " + (errors.question3 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Sonstiges</>} className=" pb-2 text-green">
					<input type="checkbox" {...register("question3")} name="question3" value="e" className={"peer absolute hidden h-1 w-1 " + (errors.question3 ? " js-formerror " : "")} />
				</ElemCheckboxMafo>
				{hasOtherOptionSelected && (
					<>
						<textarea {...register("question3Other")} name="question3Other" maxLength={99} className="h-[150px] w-full bg-[#F7F7F7] py-4 px-2 border-blue border-[1px]"></textarea>
					</>
				)}
			</div>
		</>
	)
}

export default MafoQuestionThree
